/** Band-limited PeriodicWave timbres, built once per context. */

export interface WaveBank {
  /** Saw with a soft high roll-off — airy pads. */
  readonly softSaw: PeriodicWave;
  /** Rounded, mostly-low harmonics — warm sky pad. */
  readonly warm: PeriodicWave;
  /** Odd-heavy, hollow — breathy reed/ney-like dunes drone. */
  readonly reed: PeriodicWave;
  /** Very rich with a buzzing formant (the tanpura "jawari"). */
  readonly tanpura: PeriodicWave;
}

function make(ctx: BaseAudioContext, n: number, amp: (k: number) => number): PeriodicWave {
  const real = new Float32Array(n + 1);
  const imag = new Float32Array(n + 1);
  for (let k = 1; k <= n; k++) imag[k] = amp(k);
  return ctx.createPeriodicWave(real, imag);
}

export function createWaves(ctx: BaseAudioContext): WaveBank {
  return {
    softSaw: make(ctx, 32, (k) => (1 / k) * Math.exp(-k / 14)),
    warm: make(ctx, 16, (k) => 1 / Math.pow(k, 1.7)),
    reed: make(ctx, 24, (k) => ((k & 1) === 1 ? 1 / k : 0.28 / k) * Math.exp(-k / 18)),
    tanpura: make(ctx, 48, (k) => (1 / Math.pow(k, 0.75)) * (1 + 1.3 * Math.exp(-(((k - 11) / 4) ** 2)))),
  };
}
